import {Injectable} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {UserService} from "../core/user/user.service";
import Bugsnag from '@bugsnag/js'

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private toastr: ToastrService,
    public userService: UserService,
  ) {
  }

  public buildRedirectUrl(urlToParse): string {

    // Vérifier que l'URL à parser est définie
    if (!urlToParse || typeof urlToParse !== 'string') {
      console.warn('[UrlService] urlToParse is invalid:', urlToParse);
      return urlToParse || '';
    }

    // Vérifier que l'utilisateur est chargé avant d'accéder à extProfiles
    const user = this.userService.user$.value;
    if (!user || !user.extProfiles) {
      console.warn('[UrlService] User or extProfiles is null, cannot build redirect URL:', urlToParse);
      return urlToParse; // Retourner l'URL non parsée en cas d'erreur
    }

    const uriSearch = user.extProfiles; // URI.search(true);
    // console.log('uriSearch', uriSearch);

    //
    // Vérif qu'on a ce qu'il faut
    //
    const tags = urlToParse.match(/{{\s*[\w\.]+\s*}}/g)?.map(function (x) {
      return x.match(/[\w\.]+/)[0];
    });

    if (tags) {
      if (tags.length > 0) {
        const missingTags = [];

        tags.forEach(function (t) {
          if (!uriSearch[t]) {
            missingTags.push(t);
          }
        });

        if (missingTags.length > 0) {
          const errorMsg = missingTags.join('<br>') + ' tags are missing in URL...' + `Url: ${urlToParse}`
          Bugsnag.notify(new Error(errorMsg + `Url: ${urlToParse}`), (event) => {
            event.addMetadata('Url Service', {
              message: errorMsg
            })
          })
          console.warn(errorMsg)
        }

      }
    }

    return this.interpolate(urlToParse)(uriSearch);

  }

  public interpolate(str) {
    return function interpolate(o) {
      return str.replace(/{{([^{}]*)}}/g, function (a, b) {
        const r = o[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
      });
    }
  }


}
